module.exports = __webpack_public_path__ + "static/media/noimg-800x800.f4be1733.jpg";